import * as React from 'react';
import Icons from '../icons';

export default class Emptyactivity extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
        <div className="alignCenter workkardActivity">
            <div className="emptyScreen">
                <Icons name="Emptyactivity" className="" />    <br />
                {
                    this.props.isSearchResult ?
                    <h2>No activities found</h2>
                    :
                    <React.Fragment>
                        <h2>No activities</h2>
                        <p>Create an activity.</p>
                    </React.Fragment>
                }
            </div>
        </div>
        );
    }
}